import React from 'react';
import moment from 'moment';
import { Box, Tooltip, Typography } from '@mui/material';

const DATE_KEY_FORMAT = 'YYYY-MM-DD';

const getTaskTherapyIds = task => {
  const parsedTherapyIds = `${task?.therapy_ids || ''}`
    .split(',')
    .map(value => Number(value.trim()))
    .filter(Boolean);

  if (task?.therapy_id) {
    parsedTherapyIds.push(Number(task.therapy_id));
  }

  return [...new Set(parsedTherapyIds)];
};

const isGuidedTherapy = therapy =>
  !!therapy && !therapy.clinic_administered && therapy.therapy_type !== 4;

const buildTooltipLine = therapy => {
  const daysSupply = therapy.days_supply;

  if (!daysSupply) {
    return null;
  }

  const supplyLabel = Number(daysSupply) === 1 ? 'day supply' : 'days supply';
  return `${therapy.drug_name} - ${daysSupply} ${supplyLabel}`;
};

export const getNbdCalendarGuidance = (tasksByKey = {}, therapiesById = {}) => {
  const guidanceByDate = {};

  Object.values(tasksByKey).forEach(task => {
    if (task?.taskType !== 'Order' || !task?.due_date) {
      return;
    }

    const dateKey = moment.utc(task.due_date).format(DATE_KEY_FORMAT);
    const tooltipLines = getTaskTherapyIds(task)
      .map(therapyId => therapiesById[therapyId])
      .filter(isGuidedTherapy)
      .map(buildTooltipLine)
      .filter(Boolean);

    if (!tooltipLines.length) {
      return;
    }

    guidanceByDate[dateKey] = guidanceByDate[dateKey] || [];
    tooltipLines.forEach(line => {
      if (!guidanceByDate[dateKey].includes(line)) {
        guidanceByDate[dateKey].push(line);
      }
    });
  });

  const highlightedDates = Object.keys(guidanceByDate).map(dateKey =>
    moment(dateKey, DATE_KEY_FORMAT).toDate(),
  );

  return {
    highlightDates: highlightedDates.length
      ? [{ 'react-datepicker__day--highlighted': highlightedDates }]
      : [],
    renderDayContents: (day, date) => {
      const dateKey = moment(date).format(DATE_KEY_FORMAT);
      const tooltipLines = guidanceByDate[dateKey];

      if (!tooltipLines?.length) {
        return day;
      }

      return (
        <Tooltip
          title={
            <Box>
              {tooltipLines.map(line => (
                <Typography key={line} variant="caption" display="block">
                  {line}
                </Typography>
              ))}
            </Box>
          }
          placement="top"
        >
          <span className="react-datepicker__day-guidance-content">{day}</span>
        </Tooltip>
      );
    },
  };
};
